var Entry = /** @class */ (function () {
    function Entry(key, value) {
        this.key = key;
        this.value = value;
    }
    return Entry;
}());
var LRUMap = /** @class */ (function () {
    function LRUMap(limit) {
        this._size = 0;
        this._keymap = {};
        this._limit = limit;
    }
    LRUMap.prototype.get = function (key) {
        var entry = this._keymap[key];
        if (!entry) {
            return;
        }
        this._moveToHead(entry);
        return entry.value;
    };
    LRUMap.prototype.set = function (key, value) {
        var entry = this._keymap[key];
        // update entry
        if (entry) {
            entry.value = value;
            this._moveToHead(entry);
            return;
        }
        // new entry
        entry = new Entry(key, value);
        this._keymap[key] = entry;
        if (this._head) {
            this._head.head = entry;
            entry.tail = this._head;
        }
        else {
            this._tail = entry;
        }
        this._head = entry;
        ++this._size;
        if (this._size > this._limit) {
            this.shift();
        }
    };
    LRUMap.prototype.shift = function () {
        // remove tail
        var tailEntry = this._tail;
        if (tailEntry) {
            if (tailEntry.head) {
                this._tail = tailEntry.head;
                this._tail.tail = undefined;
            }
            else {
                this._tail = this._head = undefined;
            }
            tailEntry.head = tailEntry.tail = undefined;
            delete this._keymap[tailEntry.key];
            --this._size;
        }
    };
    LRUMap.prototype.clear = function () {
        this._size = 0;
        this._tail = this._head = undefined;
        this._keymap = {};
    };
    LRUMap.prototype._moveToHead = function (entry) {
        if (entry === this._head) {
            return;
        }
        if (entry.head) {
            if (entry === this._tail) {
                this._tail = entry.head;
            }
            entry.head.tail = entry.tail;
        }
        if (entry.tail) {
            entry.tail.head = entry.head;
        }
        entry.head = undefined;
        entry.tail = this._head;
        if (this._head) {
            this._head.head = entry;
        }
        this._head = entry;
    };
    return LRUMap;
}());
export default LRUMap;
